var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMinimizeSidebar = function SvgMinimizeSidebar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.098c0-3.394 0-5.09 1.054-6.145C4.11 2.898 5.806 2.898 9.2 2.898h3.6c3.394 0 5.091 0 6.146 1.055C20 5.007 20 6.704 20 10.098v1.8c0 3.395 0 5.092-1.054 6.146-1.055 1.054-2.752 1.054-6.146 1.054H9.2c-3.394 0-5.091 0-6.146-1.054C2 16.99 2 15.293 2 11.898v-1.8Z",
    stroke: "currentColor",
    strokeWidth: 1.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3 19.102v-16.2",
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.776h-6.6m0 0L12.875 8.3M10.4 10.776l2.475 2.475",
    stroke: "currentColor",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMinimizeSidebar;